import { getParser } from 'bowser';

export const isIpad = () => {
  // iPadの「デスクトップ用Webサイトを表示」機能では、Mac * Safariと同じUserAgentになるため、
  // standaloneを使って判定する
  return (
    navigator.userAgent.indexOf('iPad') > -1 ||
    ('standalone' in navigator && navigator['standalone'] !== undefined)
  );
};
export const isDesktop = () => {
  const browser = getParser(window.navigator.userAgent);

  return !isIpad() && browser.parsePlatform().type === 'desktop';
};
